// components/ScreenViewLogger.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEmployeeAction } from '../loginactions/index';

const screenNames = {
'/Dhanshakthi-AdminLogin': 'Login Page',
  // Main Navigation
  '/dashboards/crm': 'Dashboard Home',

  // Company Navigation
  '/addcompany/district': 'Create District',
  '/addcompany/company': 'Create Company',
  '/addcompany/group': 'Create Group',
  '/addcompany/employee': 'Create Employee',
  '/addcompany/changepassword': 'Change Password',
  '/addcompany/addbanner': 'Add Banners',
  '/addcompany/addannouncement': 'Add Announcements',
  '/addcompany/rolesandresponsbilities': 'Roles & Responsibilities',
  '/addcompany/assigndealers': 'Assign Dealers',

  // Upload Points
  '/uploadPoints/electriciantransferpoints': 'Upload Admin Electrician Points',

  // Personnel Navigation
  '/addpersonnel/manager': 'Manager Dashboard',
  '/addpersonnel/representative': 'Sales Executive Dashboard',
  '/addpersonnel/dealer': 'Dealer Dashboard',
  '/addpersonnel/salesboy': 'SalesBoy Dashboard',
  '/addpersonnel/electrician': 'Electrician Dashboard',
  '/addpersonnel/dealerapplogin': 'Dealer App Login Report',

  // Schemes
  '/giftscheme/dealergiftscheme': 'Dealer Gift Scheme',
  '/giftscheme/electriciangiftscheme': 'Electrician Gift Scheme',

  // QR Code
  '/qrcode/qrcodes': 'Generate QR Codes',
  '/qrcode/qrreports': 'QR Reports',
  '/qrcode/usedqrcodes': 'Used QR Codes',
  '/qrcode/SearchQrCodeStatus': 'Search QR Code Status',
  '/qrcode/qrcreatedreport': 'QR Created Report',

  // Points Transfer
  '/points/electriciantransferpoints': 'Dealer To Electrician Points Transfer',
  '/points/salesboytransferpoints': 'Dealer To Salesboy Points Transfer',

  // Gift Management - Electrician
  '/giftmanagementelectirician/reedemgift': 'Electrician Gift Selection',
  '/giftmanagementelectirician/giftdeveliveredorpending': 'Electrician Gift Delivery Status',
  '/giftmanagementelectirician/gifthold': 'Electrician Gift Hold',
  '/giftmanagementelectirician/electriciangiftcancel': 'Electrician Gift Cancel',

  // Gift Management - Dealer
  '/giftmanagementDealer/selectgift': 'Dealer Gift Selection',
  '/giftmanagementDealer/giftdeveliveredorpendingdealer': 'Dealer Gift Delivery Status',
  '/giftmanagementDealer/dealergifthold': 'Dealer Gift Hold',
  '/giftmanagementDealer/dealergiftcancel': 'Dealer Gift Cancel',

  // Reports
  '/records/electricianReports': 'Electrician Reports',
  '/records/dealerReports': 'Dealer Reports',
  '/reports/electricianledgerreports': 'Electrician Ledger Report',
  '/reports/dealerledgerreports': 'Dealer Ledger Report',

  // Personal Dashboard
  '/personaldashboard/electriciandashboard': 'Electrician Dashboard',
  '/personaldashboard/dealerdashboard': 'Dealer Dashboard',
  '/personaldashboard/salesboydashboard': 'SalesBoy Dashboard',
  '/personaldashboard/salesexcutivedashboard': 'Sales Executive Dashboard',
  '/personaldashboard/dealermonthwisereports': 'MothWise Reports',
  // Sale Orders
  '/saleorders/item-management': 'Item Management',
  '/saleorders/item-positions': 'Item Positions',
  '/saleorders/order-management': 'Order Management',
  '/saleorders/edit-orders': 'Edit Orders',
  '/saleorders/in-voice': 'Invoice',
  '/saleorders/dealer-orderhistory': 'Order History',
  '/saleorders/order-creation': 'Order Creation',

  // Login

};

export const ScreenViewLogger = ({ children }) => {
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    // Get the screen name from our mapping or use the pathname as fallback
    const screenName = screenNames[pathname] || pathname;
    
    // Only log if the screen name exists and we're not on the login page
    if (screenName && pathname !== '/Dhanshakthi-AdminLogin') {
      logEmployeeAction('SCREEN_VIEW', screenName);
    }
  }, [pathname]);

  return children;
};

export default ScreenViewLogger;